import api from 'api'

export type MarkJetAssignmentsReturnRequestedResponse = {
  updatedAssignmentIds: string[]
  notFoundAssignmentIds: string[]
  updatedCount: number
  notFoundCount: number
}

// Uploads a CSV of assignment ids (first column, header optional) and marks
// each matching `jet_assignment` as return-requested.
export const markJetAssignmentsReturnRequested = async (
  file: File
): Promise<MarkJetAssignmentsReturnRequestedResponse> => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await api.post<MarkJetAssignmentsReturnRequestedResponse>(
    '/admin/jet/assignments/return_requested',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return response.data
}
